import { notifyError } from 'shared/errors'
import { useMount } from 'shared/hooks'

const listenErrors = ({ error }: ErrorEvent) => notifyError(error)

export const useListeners = () =>
	useMount(() => {
		window.addEventListener('error', listenErrors)

		return () => window.removeEventListener('error', listenErrors)
	})
